<div class="flex flex-col gap-3">
	<div class="flex justify-between">
		<h4 *ngIf="type !== 'emailSubject'">
			<strong>Editing Tag:</strong> {{ tagLabel }}
		</h4>
		<h4 *ngIf="type === 'emailSubject'">
			<strong>Editing:</strong> {{ tagLabel }}
		</h4>
		<p class="cursor-pointer font-bold" (click)="reset()">Reset</p>
	</div>
	<textarea
		class="border rounded-md p-3"
		*ngIf="!showHtmlEditor"
		[ngModel]="tag"
		(ngModelChange)="onChange($event)"
		[ngStyle]="{ height: height }"
	></textarea>
	<div *ngIf="showHtmlEditor">
		<app-html-mini-editor
			class="mceNonEditable"
			[debounceTime]="0"
			[document]="tag"
			(onChange)="onChange($event)"
			minHeight="400px"
		></app-html-mini-editor>
	</div>
	<div class="flex justify-between">
		<app-button btn="tertiary" size="small" (click)="closeModal()"
			>Cancel</app-button
		>
		<app-button size="small" (click)="save()">Save</app-button>
	</div>
</div>
